module.exports = __webpack_public_path__ + "assets/img/ff5b86297e098298648820b9538cb627.png";